var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("form", { attrs: { "data-vv-scope": "step-3-part-1" } }, [
      _vm._m(0),
      _c("div", { staticClass: "row mb-3" }, [
        _vm._m(1),
        _c(
          "div",
          { staticClass: "col-md-4 d-flex align-items-end" },
          [
            _c("UploadFile", {
              attrs: {
                permission: "*",
                text: "Seleccionar archivo",
                accept: ".pdf,.rar,.zip,",
                "max-size-in-mb": 30,
                "upload-to": "ed",
                "button-class": "btn-block",
                "container-class": "w-100"
              },
              model: {
                value: _vm.step.mainFile,
                callback: function($$v) {
                  _vm.$set(_vm.step, "mainFile", $$v)
                },
                expression: "step.mainFile"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _vm._m(2),
        _c(
          "div",
          { staticClass: "col-md-4 d-flex align-items-end" },
          [
            _c("UploadFile", {
              attrs: {
                permission: "*",
                text: "Seleccionar archivo",
                accept: ".pdf,.rar,.zip,",
                "max-size-in-mb": 30,
                "upload-to": "ed",
                "button-class": "btn-block",
                "container-class": "w-100"
              },
              on: {
                input: function($event) {
                  return _vm.addAdditionalFile()
                }
              },
              model: {
                value: _vm.additionalFile,
                callback: function($$v) {
                  _vm.additionalFile = $$v
                },
                expression: "additionalFile"
              }
            })
          ],
          1
        )
      ]),
      _vm.step.mainFile.name || _vm.step.additionalFiles.length
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "b-table-simple",
                  { attrs: { hover: "", small: "" } },
                  [
                    _c(
                      "b-thead",
                      [
                        _c(
                          "b-tr",
                          [
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre archivo")
                            ]),
                            _c("b-th", { attrs: { scope: "col" } }, [
                              _vm._v("Nombre documento")
                            ]),
                            _c(
                              "b-th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" }
                              },
                              [_vm._v("Interno")]
                            ),
                            _c(
                              "b-th",
                              {
                                staticClass: "text-center",
                                attrs: { scope: "col" }
                              },
                              [_vm._v("-")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.step.mainFile.name
                      ? _c(
                          "b-tbody",
                          [
                            _c(
                              "b-tr",
                              [
                                _c("b-td", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Principal",
                                          expression: "'Principal'"
                                        }
                                      ],
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("vs-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          icon: "file_present",
                                          size: "medium"
                                        }
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.step.mainFile.name) +
                                          " "
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _c(
                                  "b-td",
                                  [
                                    _c("vs-input", {
                                      staticClass: "w-100",
                                      model: {
                                        value:
                                          _vm.step.mainFile.currentDescription,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.step.mainFile,
                                            "currentDescription",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "step.mainFile.currentDescription"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("b-td")
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.step.additionalFiles.length
                      ? _c(
                          "b-tbody",
                          _vm._l(_vm.step.additionalFiles, function(file) {
                            return _c(
                              "b-tr",
                              { key: file.id },
                              [
                                _c("b-td", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Principal",
                                          expression: "'Principal'"
                                        }
                                      ],
                                      staticClass: "d-flex align-items-center"
                                    },
                                    [
                                      _c("vs-icon", {
                                        staticClass: "mr-1",
                                        attrs: {
                                          icon: "file_present",
                                          size: "medium"
                                        }
                                      }),
                                      _vm._v(" " + _vm._s(file.name) + " ")
                                    ],
                                    1
                                  )
                                ]),
                                _c(
                                  "b-td",
                                  [
                                    _c("vs-input", {
                                      staticClass: "w-100",
                                      model: {
                                        value: file.currentDescription,
                                        callback: function($$v) {
                                          _vm.$set(
                                            file,
                                            "currentDescription",
                                            $$v
                                          )
                                        },
                                        expression: "file.currentDescription"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-td",
                                  { staticClass: "text-center" },
                                  [
                                    _c("vs-checkbox", {
                                      staticClass: "ml-5 pl-5",
                                      model: {
                                        value: file.interno,
                                        callback: function($$v) {
                                          _vm.$set(file, "interno", $$v)
                                        },
                                        expression: "file.interno"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "b-td",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "outline-danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeAdditionalFile(
                                              file.id
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(" remover ")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
      ])
    ]),
    _c("form", { attrs: { "data-vv-scope": "step-3-part-2" } }, [
      _vm._m(3),
      _vm.view === "numOf"
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: { label: "Código RIF", name: "rifCode" },
                  model: {
                    value: _vm.step.rifCode,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "rifCode", $$v)
                    },
                    expression: "step.rifCode"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    label: "Número expediente",
                    name: "documentNumber",
                    "data-cy": "document-number"
                  },
                  model: {
                    value: _vm.step.fileNumberEntry,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "fileNumberEntry", $$v)
                    },
                    expression: "step.fileNumberEntry"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: { label: "Número RIDEX", name: "rifCode" },
                  model: {
                    value: _vm.step.numberRidex,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "numberRidex", $$v)
                    },
                    expression: "step.numberRidex"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    label: "Número SAC",
                    name: "documentNumber",
                    "data-cy": "sac-number"
                  },
                  model: {
                    value: _vm.step.numberSac,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "numberSac", $$v)
                    },
                    expression: "step.numberSac"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6 mt-3" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: { label: "Id Adquisiciones", name: "rifCode" },
                  model: {
                    value: _vm.step.numberAcquisitions,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "numberAcquisitions", $$v)
                    },
                    expression: "step.numberAcquisitions"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.view === "numOf"
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
          ])
        : _vm._e(),
      _vm.isMop
        ? _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("vs-input", {
                  staticClass: "w-100",
                  attrs: {
                    label: "Contrato SAFI",
                    maxlength: "10",
                    name: "safiContract"
                  },
                  model: {
                    value: _vm.step.safiContract,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "safiContract", $$v)
                    },
                    expression: "step.safiContract"
                  }
                })
              ],
              1
            ),
            _vm._m(4)
          ])
        : _vm._e(),
      _vm.isMop
        ? _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-12" }, [_c("vs-divider")], 1)
          ])
        : _vm._e(),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("list-all-document-types", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              ref: "documentTypes",
              staticClass: "w-100",
              attrs: {
                usage: "referencias",
                autocomplete: "",
                label: "Tipo Documento",
                name: "documentType",
                danger: _vm.errors.has("step-3-part-2.documentType"),
                "danger-text": _vm.errors.first("step-3-part-2.documentType")
              },
              model: {
                value: _vm.relatedDocument.type,
                callback: function($$v) {
                  _vm.$set(_vm.relatedDocument, "type", $$v)
                },
                expression: "relatedDocument.type"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-6" },
          [
            _c("vs-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              staticClass: "w-100",
              attrs: {
                label: "Nº Documento",
                name: "relatedDocumentNumber",
                danger: _vm.errors.has("step-3-part-2.relatedDocumentNumber"),
                "danger-text": _vm.errors.first(
                  "step-3-part-2.relatedDocumentNumber"
                )
              },
              model: {
                value: _vm.relatedDocument.number,
                callback: function($$v) {
                  _vm.$set(_vm.relatedDocument, "number", $$v)
                },
                expression: "relatedDocument.number"
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 d-flex align-items-end justify-content-end" },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  "data-cy": "add-relationship-button",
                  color: "primary",
                  icon: "add"
                },
                on: {
                  click: function($event) {
                    return _vm.addRelatedDocument()
                  }
                }
              },
              [_vm._v(" Agregar relación ")]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "vs-table",
              {
                staticClass: "pb-2 mb-2",
                attrs: {
                  multiple: "",
                  "no-data-text": "No tienes documentos relacionados",
                  data: _vm.step.relatedDocuments
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var data = ref.data
                      return _vm._l(data, function(tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr, attrs: { data: tr } },
                          [
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].type } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.findLabelDocument(tr.type)) +
                                    " "
                                )
                              ]
                            ),
                            _c(
                              "vs-td",
                              { attrs: { data: data[indextr].number } },
                              [_vm._v(" " + _vm._s(tr.number) + " ")]
                            )
                          ],
                          1
                        )
                      })
                    }
                  }
                ]),
                model: {
                  value: _vm.step.relatedDocumentsSelected,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "relatedDocumentsSelected", $$v)
                  },
                  expression: "step.relatedDocumentsSelected"
                }
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Relacionado con")]),
                    _c("vs-th", [_vm._v("Nº Documento")])
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Adjuntar Documento")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("Documento principal")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("Documentos adicionales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Documentos Relacionados")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          staticClass:
            "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
          staticStyle: {
            height: "32px",
            "font-size": "12px",
            color: "#673ab7 !important"
          }
        },
        [
          _c("span", { staticClass: "span-text-validation" }, [
            _vm._v(
              " El número de Contrato SAFI en muchos casos es requerido, no lo olvides! "
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }